module.exports = __webpack_public_path__ + "img/xcx-case09.db763877.png";